import { COLOR_TERTIARY, NAV_Z_INDEX } from "../../../theme";
import styled from "@emotion/styled";

const Nav = styled.nav`
  background-color: ${COLOR_TERTIARY};
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: ${NAV_Z_INDEX};
  padding: 0 16px 0 24px;
`;

export default Nav;
